module.exports = __webpack_public_path__ + "922e8168.svg";